import { useMutation } from '@tanstack/react-query';
import type { SubmitLeadRequest, SubmitLeadResponse } from '@pms/shared';
import { submitLead } from '../services/api/leads.api';

/**
 * Submit a "List your property" lead. No cache to invalidate (write-only, public),
 * so this is a plain mutation. Consumers read `mutate`, `isPending`, `isSuccess`,
 * `error` to drive the form's submitting / success / error states.
 */
export function useSubmitLead() {
  return useMutation<SubmitLeadResponse, unknown, SubmitLeadRequest>({
    mutationFn: submitLead,
  });
}
